import React from 'react';
import FooterLinksColumn from './FooterLinksColumn';

const columns = [
  {
    title: "A propos",
    link: '/about-us'
  },
  {
    title: "Communauté",
    link: '/community'
  },
  {
    title: "Devenir Tuteur",
    link: '/become-an-instructor'
  },
  {
    title: "Blog",
    link: '/blog'
  },
  {
    title: "Offre Ecoles",
    link: '/school-offer'
  }
];

const FooterColumns = ({ textColor = 'text-white' }) => {
  return (
    <div className={`grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-6 md:gap-8 py-8 md:py-12 mb-8 md:mb-16 ${textColor}`}>
      {columns.map((column, index) => (
        <FooterLinksColumn
          key={index}
          title={column.title}
          link={column.link}
          doubleColumn={column.doubleColumn}
          textColor={textColor}
        />
      ))}

      <div className="col-span-2 md:col-span-3 lg:col-span-2 space-y-4">
        <h4 className="text-sm md:text-base font-medium uppercase">GET IN TOUCH</h4>
        <p className="text-xs md:text-sm">We don't send spam so don't worry.</p>
        <form className="relative w-full max-w-xs md:max-w-md">
          <input
            type="email"
            placeholder="Email..."
            className={`w-full px-4 py-3 pr-24 md:pr-32 rounded-full bg-white text-black text-xs md:text-sm`}
          />
          <button
            type="submit"
            className="absolute right-1 top-1/2 transform -translate-y-1/2 px-3 py-1 md:px-4 md:py-2
            text-white bg-[#6440FB] rounded-full text-xs md:text-sm font-medium"
          >
            Submit
          </button>
        </form>
      </div>
    </div>
  );
};

export default FooterColumns;